$(document).ready(function(){

	/*submitting*/
	$('form.handlethis').submit(function(e){

		e.preventDefault();

		/*prepare*/
		const trigger = $(this).find('button.submitnow');
		trigger.html(trigger.attr('sending'));

		/*create form data*/
		var data = new FormData($(this)[0]);

		/*add metas*/
		data.append('subject',trigger.attr('subject'));
		data.append('receiver',trigger.attr('receiver'));

		/*post*/
		$.ajax({
			type: 'POST',
			url: './theme/public/assets/handler/handle.form.php',
			data: data,
			async: true,
			cache: false,
			contentType: false,
			processData: false,
			success: function(reply){

				/*feedback*/
				if(reply == 'ok'){
					trigger.html(trigger.attr('success'));
					trigger.prop('disabled', true);
					trigger.addClass('sent');

					setTimeout(function(){
						$('form.handlethis').each(function() {
							this.reset();
							$('form.handlethis').find('select').prop('selectedIndex', 0);
							$('form.handlethis').find('input:not([readonly]), textarea').each(function() {
								$(this).val('').focus().blur();
							});
							trigger.prop('disabled', false);
							trigger.html(trigger.attr('label'));
						});
					}, 5000);

				}else{
					trigger.html(trigger.attr('error'));
				}

			}

		});

	});

});
